import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, Modal, Button, Grid, Card, Image } from '@mantine/core';
import TestsApi from '../../api/TestsApi';
import { VisiLoader, HelpTip } from '../GeneralComponent/GeneralComponent';
import { UniversalSmartCodeContent, useUniversalSmartCode } from '../GeneralComponent/UniversalSmartCodeContent';

export function CreateTestSmartCodeModal({ selectedMemberWebsite, pageId, selectedFunnelName, taguchi_type_id, activeTestId, isVisiSmartCodeModalOpen, onVisiSmartCodeClose, testType, setCheckValidate }: any) {

  const navigate = useNavigate();
  const [smartCodeModel, setSmartCodeModel] = useState(false);
  const [testingCode, setTestingCode] = useState([]);
  const [validateErrorMsg, setValidateErrorMsg] = useState('');
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);

  // Universal smart code is fetched (and shown) only once a page is found to be missing it
  const { data, loading: codeLoading } = useUniversalSmartCode({
    websiteId: selectedMemberWebsite,
    isSubdomain: false,
    subdomainId: '',
    pageId,
    enabled: smartCodeModel,
  });



  // Validate the smart code is installed; show the universal code popup when it is missing
  const checkVisismartCode = (checkValidate:any = '') => {
    const dataObject = {
      system_website_id: selectedMemberWebsite,
      page_id: pageId,
      visi_test_funnel: selectedFunnelName
    } as any;
    if(checkValidate){
      dataObject.check_validate = checkValidate === true ? 1 : 0;
    }
    if(testType === 'classic_test'){
      dataObject.test_type = testType;
    }
    setIsVisiLoaderVisible(true);
    TestsApi.getvisismartcodelist(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else if (response.status === 401 || response.status === 400) {
        navigate("/logout");
        setIsVisiLoaderVisible(false);
      }
    })
    .then(data => {
      if(data.status === 1){
        setIsVisiLoaderVisible(false);
        setSmartCodeModel(false);
        onVisiSmartCodeClose(false);
        if(testType === 'classic_test'){
          setCheckValidate(true);
        }else{
          navigate("/reviewing-test", { state: { pageId: pageId, taguchiTestId:taguchi_type_id, funnelId:selectedFunnelName, testsId:activeTestId } });
        }
      }else{
        setTestingCode(data.data.testing_code || []);
        setValidateErrorMsg(data.data.error_message);
        setSmartCodeModel(true);
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  };

  const handleCheckValidate = () => {
    checkVisismartCode(true);
  };

  useEffect(() => {
    if(isVisiSmartCodeModalOpen){
      checkVisismartCode();
    }
  }, [isVisiSmartCodeModalOpen]);

  // Warn the user before leaving while the smart code popup is open
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    if (smartCodeModel) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [smartCodeModel]);

  return (
    <>
      <VisiLoader VisiLoaderVisible={isVisiLoaderVisible || codeLoading} />
      <Modal.Root size="70%" opened={smartCodeModel} onClose={() => {}} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>UNIVERSAL SMART CODE <HelpTip helpId={data.frontendFramework === '3' ? 369 : data.frontendFramework === '2' ? 372 : data.frontendFramework === '1' ? 374 : data.frontendFramework === '0' ? 377 : 188} /></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <Text color="red" size="md" weight={500}>{validateErrorMsg}</Text>
            {/*PAGE PREVIEWS - pages still missing the smart code (classic AB test)*/}
            {testType === 'classic_test' && testingCode.length > 0 && (
              <>
                <Text fw={700} size="sm" fz={14} mt={10} mb={8}>These pages still need the Visiopt Smart Code:</Text>
                <Grid mb={15}>
                  {testingCode.map((element, index) => (
                    <Grid.Col span={3} key={index}>
                      <Card shadow="sm" padding="sm" radius="md" withBorder>
                        <Card.Section component="a" href={element.preview_page_url} target="_blank" rel="noreferrer">
                          <Image src={element.thumb} height={130} fit="cover" alt={element.custom_title} withPlaceholder />
                        </Card.Section>
                        <Text size="sm" fw={500} mt={8} ta="center" lineClamp={1} title={element.custom_title}>
                          {element.custom_title}
                        </Text>
                        <Button component="a" href={element.preview_page_url} target="_blank" rel="noreferrer" variant="light" size="xs" fullWidth mt={8}>
                          Preview Page
                        </Button>
                      </Card>
                    </Grid.Col>
                  ))}
                </Grid>
              </>
            )}
            <UniversalSmartCodeContent
              data={data}
            />
            <Grid justify="flex-end">
              <Grid.Col span={1}>
                <Button size="sm" w={80} mt={10} color="teal" fullWidth onClick={handleCheckValidate}>
                  Done
                </Button>
              </Grid.Col>
            </Grid>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
